<template>
  <vxe-modal v-model="BankBranch" title="选择开户网点" width="1000" height="800" resize>
    <vxe-toolbar fixed="top">
      <template v-slot:buttons>
        <el-button type="primary" @click="clearRadioRowEevnt">取消选中</el-button>
        <el-button type="primary" @click="getRadioEvent1">获取选中</el-button>
        <el-button type="primary" @click="funcFilter">查询</el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable1"
      height="500"
      border
      class="radio-table"
      :data="tableData"
      :radio-config="{highlight: true}"
      @radio-change="radioChangeEvent"
    >
      <vxe-table-column type="radio" width="60" />
      <vxe-table-column>
        <vxe-table-column field="bankName" title="支行名称" min-width="280" />
        <template v-slot:header>
          <el-input v-model="listQuery.bankName" placeholder clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="bankNo" title="支行号" min-width="150" />
        <template v-slot:header>
          <el-input v-model="listQuery.bankNo" placeholder clearable />
        </template>
      </vxe-table-column>
    </vxe-table>

    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
      @page-change="handlePageChange"
    />
  </vxe-modal>
</template>

<script>
import { getBankAssociationNumber } from "@/api/bankCard";
export default {
  name: "BankBranchList",
  data() {
    return {
      loading: false,
      BankBranch: false,
      getdata: [],
      listQuery: {
        bankName: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      Pagingconf: [],
      tableData: [],
      // 机构列表
      branchList: this.$store.state.components.branchList
    };
  },
  created() {},
  methods: {
    show(bankNo){
      this.listQuery.bankCode = bankNo
      this.BankBranch = true
      this.getInfo()
    },
    // 获取中台银行网点、联行号
    async getInfo() {
      this.loading = true
      let response = await getBankAssociationNumber(this.listQuery)
      this.loading = false
      this.tableData = response.data.records;
      this.listQuery.total = response.data.total;
      response.data.total? this.Pagingconf = [20, 30, 50, 100, response.data.total] : this.Pagingconf = [20, 30, 50, 100];
    },
    // 查询
    funcFilter() {
      this.listQuery.pageNum = 1;
      this.getInfo();
    },
    // 获取选中
    getRadioEvent1() {
      this.getdata = this.$refs.xTable1.getRadioRecord();
      this.$emit("event", this.getdata);
      this.BankBranch = false
    },
    // 取消选中
    clearRadioRowEevnt() {
      this.selectRow = null;
      this.$refs.xTable1.clearRadioRow();
    },
    // 选中事件
    radioChangeEvent({ row }) {
      this.selectRow = row;
    },
  }
};
</script>
